var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Question = /** @class */ (function () {
    function Question(_a) {
        var kind = _a.kind, questionUniqueLabel = _a.questionUniqueLabel, url = _a.url;
        this.kind = kind;
        this.questionUniqueLabel = questionUniqueLabel;
        this.url = url;
    }
    Question.fromApi = function (props) {
        return new Question(__assign({}, props));
    };
    return Question;
}());
export { Question };
